(function () {
  'use strict';

  var VERBOSE = true;
  function log() {
    if (!VERBOSE) return;
    var args = ['[BXGY]'].concat(Array.prototype.slice.call(arguments));
    console.debug.apply(console, args);
  }

  var CONFIG_SELECTOR = '#bxgy-offers-config';
  var PICKER_TEMPLATE = '#bxgy-picker-template';
  var CARD_TEMPLATE = '#bxgy-product-card-template';
  var DEBOUNCE_MS = 500;
  var CHECKOUT_GATE_TIMEOUT_MS = 3000;
  var EVENT_GRANTED = 'BXGY Reward Granted V.1';
  var EVENT_GRANT_FAILED = 'BXGY Reward Grant Failed V.1';
  var GRANT_FAILED_PROPERTY = '_bxgy_grant_failed';
  var JSON_HEADERS = { 'Content-Type': 'application/json' };

  function extractNumericId(gid) {
    if (typeof gid === 'number') return gid;
    var match = String(gid).match(/(\d+)$/);
    return match ? Number(match[1]) : null;
  }

  function routesRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof root === 'string' && root ? root : '/';
  }

  function cartUrl(path) {
    return routesRoot() + String(path).replace(/^\//, '');
  }

  function parseTime(value) {
    if (!value) return NaN;
    return Date.parse(value);
  }

  function isWithinSchedule(offer, now) {
    var starts = parseTime(offer.startsAt);
    var ends = parseTime(offer.endsAt);
    if (!isNaN(starts) && starts > now) return false;
    if (!isNaN(ends) && ends < now) return false;
    return true;
  }

  function track(eventName, props) {
    try {
      var mp = window.mixpanel;
      if (mp && typeof mp.track === 'function') mp.track(eventName, props);
    } catch (e) {
      log('track failed:', e);
    }
  }

  function pageUrl() {
    try {
      return (window.location && window.location.href) || '';
    } catch (e) {
      return '';
    }
  }

  function requestUrl(url) {
    if (typeof url === 'string') return url;
    if (url && typeof url.url === 'string') return url.url;
    if (url && typeof url.href === 'string') return url.href;
    return '';
  }

  function isCartMutationUrl(urlStr) {
    return (
      urlStr.indexOf('/cart/add') !== -1 ||
      urlStr.indexOf('/cart/change') !== -1 ||
      urlStr.indexOf('/cart/update') !== -1 ||
      urlStr.indexOf('/cart/clear') !== -1
    );
  }

  function isSelfRequest(opts) {
    if (!opts) return false;
    if (opts.bxgySelf) return true;
    var headers = opts.headers;
    if (!headers) return false;
    if (typeof headers.get === 'function') return headers.get('X-BXGY-Self') === '1';
    var keys = Object.keys(headers);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].toLowerCase() === 'x-bxgy-self') return String(headers[keys[i]]) === '1';
    }
    return false;
  }

  function assign(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      if (!source) continue;
      Object.keys(source).forEach(function (key) {
        target[key] = source[key];
      });
    }
    return target;
  }

  class BxgyManager {
    constructor() {
      log('Initializing BxgyManager');
      var configEl = document.querySelector(CONFIG_SELECTOR);
      if (!configEl) {
        log('No config element found (' + CONFIG_SELECTOR + '), aborting');
        return;
      }

      var config;
      try {
        config = JSON.parse(configEl.textContent);
        log('Config parsed successfully:', config);
      } catch (e) {
        console.error('[BXGY] Failed to parse config', e);
        return;
      }

      this.currentMarket = config.currentMarket || '';
      this.currencySymbol = config.currencySymbol || '$';
      this.t = config.translations || {};
      this.customerTags = config.customerTags || [];
      this.customerLoggedIn = config.customerLoggedIn || false;
      this.discountMessages = config.discountMessages || {};
      this.pickerHeadings = config.pickerHeadings || {};
      this.rewardVariantSkuMap = config.rewardVariantSkuMap || {};
      log('Market:', this.currentMarket, '| Customer logged in:', this.customerLoggedIn, '| Customer tags:', this.customerTags);

      var marketFiltered = this._filterByMarket(config.offers || []);
      log('Offers after market filter:', marketFiltered.length, 'of', (config.offers || []).length);
      this.offers = this._filterByCustomerTags(marketFiltered);
      log('Offers after customer tag filter:', this.offers.length, 'of', marketFiltered.length);

      if (!this.offers.length) {
        log('No eligible offers remaining, aborting');
        return;
      }

      log('Active offers:', this.offers.map(function (o) { return o.id + ' (' + o.title + ')'; }));

      var self = this;
      this.offers.forEach(function (offer) {
        offer._qualifyingIds = (offer.qualifyingProductIds || [])
          .map(extractNumericId)
          .filter(Boolean);
        offer._rewardVariantIds = (offer.rewardProductVariantIds || [])
          .map(extractNumericId)
          .filter(Boolean);
        offer._rewardVariantProductMap = offer.rewardVariantProductMap || {};
        offer._rewardVariantHandleMap = {};
        offer._rewardVariantSkuMap = {};
        (offer.rewardProducts || []).forEach(function (rp) {
          var vid = rp.numericVariantId || extractNumericId(rp.variantId);
          if (vid && rp.productHandle) {
            offer._rewardVariantHandleMap[vid] = rp.productHandle;
          }
          if (vid != null) {
            var globalSku = self.rewardVariantSkuMap[vid] || self.rewardVariantSkuMap[String(vid)];
            if (globalSku) offer._rewardVariantSkuMap[vid] = globalSku;
          }
        });
        log('Offer', offer.id, '| qualifying IDs:', offer._qualifyingIds, '| reward variant IDs:', offer._rewardVariantIds);
      });

      this._evaluating = false;
      this._pendingReevaluate = false;
      this._grantPending = false;
      this._idleWaiters = [];
      this._releasedForm = null;
      this._injectingCTAs = false;
      this._debounceTimer = null;
      this._ctaObserverTimer = null;
      this._refreshSeq = 0;
      this.optOuts = new Map();
      this._rewardRemoved = new Map();
      this._grantFailures = new Map();
      this._readRetried = new Map();
      this._sessionOptOuts = this._loadSessionOptOuts();

      document.addEventListener('bxgy:reward-removed', function (e) {
        var offerId = e.detail && e.detail.offerId;
        var variantId = e.detail && e.detail.variantId;
        var sku = e.detail && e.detail.sku;
        if (!offerId) return;
        log('Reward manually removed for offer:', offerId, '| variantId:', variantId, '| sku:', sku);
        self._rewardRemoved.set(String(offerId), { variantId: variantId });
        if (!sku && variantId != null) {
          var offer = self._findOfferById(offerId);
          if (offer && offer._rewardVariantSkuMap) {
            sku = offer._rewardVariantSkuMap[variantId] || offer._rewardVariantSkuMap[String(variantId)] || null;
          }
        }
        if (!sku && variantId != null) sku = 'variant-' + variantId;
        self._recordDeclinedSku(offerId, sku).catch(function (err) {
          log('decline record failed', err);
        });
      });

      log('Installing cart intercept');
      this.installCartIntercept();
      log('Installing change selection handler');
      this.installChangeSelectionHandler();
      log('Installing checkout gate');
      this.installCheckoutGate();
      log('Running initial evaluate');
      this.evaluate();

      var cartDrawerEl = document.getElementById('CartDrawer');
      if (cartDrawerEl) {
        var observer = new MutationObserver(function () {
          clearTimeout(self._ctaObserverTimer);
          self._ctaObserverTimer = setTimeout(function () {
            log('MutationObserver: CartDrawer changed, re-injecting CTAs');
            self._injectFreeGiftCTAs(false);
          }, 100);
        });
        observer.observe(cartDrawerEl, { childList: true, subtree: true });
        log('MutationObserver installed on #CartDrawer');
      }
    }

    /* ── Filtering ── */

    _filterByMarket(offers) {
      var market = this.currentMarket;
      return offers.filter(function (offer) {
        if (offer.status !== 'active') {
          log('Offer', offer.id, 'skipped: status is', offer.status, '(not active)');
          return false;
        }

        if ((offer.segmentIds || []).length > 0) {
          log('Offer', offer.id, 'skipped: targets customer segments, which the storefront cannot evaluate');
          return false;
        }

        var allowed = offer.allowedMarkets || [];
        if (allowed.length > 0 && allowed.indexOf(market) === -1) {
          log('Offer', offer.id, 'skipped: market', market, 'not in allowedMarkets', allowed);
          return false;
        }

        return true;
      });
    }

    _filterByCustomerTags(offers) {
      var loggedIn = this.customerLoggedIn;
      var tags = this.customerTags;
      return offers.filter(function (offer) {
        var requiredTags = offer.customerTags || [];
        if (requiredTags.length === 0) return true;
        if (!loggedIn) {
          log('Offer', offer.id, 'skipped: requires tags', requiredTags, 'but customer not logged in');
          return false;
        }
        for (var i = 0; i < requiredTags.length; i++) {
          if (tags.indexOf(requiredTags[i]) !== -1) return true;
        }
        log('Offer', offer.id, 'skipped: customer tags', tags, 'do not match required', requiredTags);
        return false;
      });
    }

    /* ── Session Storage Opt-Outs ── */

    _loadSessionOptOuts() {
      try {
        var data = sessionStorage.getItem('bxgy_reward_optouts');
        var parsed = data ? JSON.parse(data) : {};
        log('Loaded session opt-outs:', parsed);
        return parsed;
      } catch (e) {
        log('Failed to load session opt-outs:', e);
        return {};
      }
    }

    _saveSessionOptOut(offerId, variantId, hash) {
      var key = String(offerId);
      this._sessionOptOuts[key] = { variantId: variantId, hash: hash };
      log('Saving session opt-out for offer:', key, '| variantId:', variantId, '| hash:', hash);
      try {
        sessionStorage.setItem('bxgy_reward_optouts', JSON.stringify(this._sessionOptOuts));
      } catch (e) {
        log('Failed to save session opt-out:', e);
      }
    }

    _removeSessionOptOut(offerId) {
      var key = String(offerId);
      delete this._sessionOptOuts[key];
      log('Removed session opt-out for offer:', key);
      try {
        sessionStorage.setItem('bxgy_reward_optouts', JSON.stringify(this._sessionOptOuts));
      } catch (e) {
        log('Failed to remove session opt-out:', e);
      }
    }

    /* ── Cart Intercept ── */

    installCartIntercept() {
      var self = this;
      var originalFetch = window.fetch;

      window.fetch = function (url, opts) {
        var urlStr = requestUrl(url);
        var isMutation = isCartMutationUrl(urlStr);
        var isSelf = isSelfRequest(opts);

        if (isMutation) {
          log('Intercepted fetch cart mutation:', urlStr, '| self:', isSelf);
        }

        var result = originalFetch.apply(window, arguments);

        if (isMutation && !isSelf) {
          result.then(function () {
            log('Cart mutation completed, scheduling debounced evaluate');
            self.debouncedEvaluate();
          }).catch(function () {});
        }

        return result;
      };

      var originalXHROpen = XMLHttpRequest.prototype.open;
      var originalXHRSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function () {
        this._bxgyUrl = arguments[1] || '';
        return originalXHROpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function () {
        var xhr = this;
        var urlStr = requestUrl(xhr._bxgyUrl);

        if (isCartMutationUrl(urlStr)) {
          log('Intercepted XHR cart mutation:', urlStr);
          xhr.addEventListener('load', function () {
            log('XHR cart mutation completed, scheduling debounced evaluate');
            self.debouncedEvaluate();
          });
        }

        return originalXHRSend.apply(this, arguments);
      };
    }

    /* ── Checkout Gate ── */

    installCheckoutGate() {
      var self = this;
      document.addEventListener(
        'submit',
        function (e) {
          var form = e.target;
          if (!form || form.id !== 'CartDrawer-Form') return;
          if (form === self._releasedForm) {
            self._releasedForm = null;
            return;
          }
          if (!self._grantPending) return;

          log('Checkout gate: holding drawer checkout until reward evaluation completes');
          e.preventDefault();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

          var submitter = self._resolveSubmitter(e, form);
          if (submitter && submitter.setAttribute) submitter.setAttribute('aria-disabled', 'true');

          self._whenIdle(function () {
            if (submitter && submitter.removeAttribute) submitter.removeAttribute('aria-disabled');
            log('Checkout gate: releasing drawer checkout');
            self._releasedForm = form;
            self._submitForm(form, submitter);
            setTimeout(function () {
              if (self._releasedForm === form) self._releasedForm = null;
            }, 0);
          }, CHECKOUT_GATE_TIMEOUT_MS);
        },
        true
      );
    }

    _resolveSubmitter(e, form) {
      var submitter = e.submitter || null;
      if (!submitter && form && typeof form.querySelector === 'function') {
        submitter = form.querySelector('[name="checkout"]');
      }
      if (!submitter) submitter = document.getElementById('CartDrawer-Checkout');
      return submitter || null;
    }

    _submitForm(form, submitter) {
      if (submitter && typeof form.requestSubmit === 'function') {
        try {
          form.requestSubmit(submitter);
          return;
        } catch (e) {
          log('requestSubmit failed, falling back to submit()', e);
        }
      }
      var name = (submitter && submitter.name) || 'checkout';
      var hidden = null;
      if (typeof form.querySelector === 'function' && !form.querySelector('input[name="' + name + '"]')) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = name;
        hidden.value = (submitter && submitter.value) || '';
        form.appendChild(hidden);
      }
      form.submit();
      if (hidden) {
        setTimeout(function () {
          if (hidden.parentNode && typeof hidden.parentNode.removeChild === 'function') hidden.parentNode.removeChild(hidden);
        }, 0);
      }
    }

    _whenIdle(callback, timeoutMs) {
      if (!this._grantPending) {
        callback();
        return;
      }
      var self = this;
      var done = false;
      var waiter = function () {
        if (done) return;
        done = true;
        clearTimeout(timer);
        callback();
      };
      var timer = setTimeout(function () {
        if (done) return;
        done = true;
        self._idleWaiters = self._idleWaiters.filter(function (w) { return w !== waiter; });
        log('Idle wait timed out after', timeoutMs, 'ms');
        callback();
      }, timeoutMs);
      this._idleWaiters.push(waiter);
    }

    _flushIdleWaiters() {
      var waiters = this._idleWaiters;
      this._idleWaiters = [];
      waiters.forEach(function (fn) {
        try {
          fn();
        } catch (e) {
          console.error('[BXGY] idle waiter failed', e);
        }
      });
    }

    /* ── Evaluation ── */

    debouncedEvaluate() {
      var self = this;
      this._grantPending = true;
      log('Debounced evaluate requested (will fire in', DEBOUNCE_MS, 'ms)');
      clearTimeout(this._debounceTimer);
      this._debounceTimer = setTimeout(function () {
        self._debounceTimer = null;
        log('Debounce timer fired, calling evaluate');
        self.evaluate();
      }, DEBOUNCE_MS);
    }

    evaluate() {
      if (this._evaluating) {
        log('Evaluate skipped: already evaluating, will re-evaluate after');
        this._pendingReevaluate = true;
        return;
      }
      this._evaluating = true;
      this._grantPending = true;
      log('Evaluate started: fetching cart');

      var self = this;

      Promise.resolve()
        .then(function () {
          return self._fetchCart();
        })
        .then(function (cart) {
          log('Cart fetched:', cart.items.length, 'items, total:', cart.total_price);
          log('Cart items:', cart.items.map(function (i) {
            return { id: i.variant_id, product_id: i.product_id, qty: i.quantity, props: i.properties };
          }));
          return self._processOffers(cart, 0);
        })
        .then(function () {
          log('Evaluate completed');
          self._finishEvaluate(null);
        })
        .catch(function (err) {
          console.error('[BXGY] Evaluation error', err);
          self._finishEvaluate(err);
        });
    }

    _finishEvaluate(err) {
      this._evaluating = false;
      var rerun = this._pendingReevaluate;
      this._pendingReevaluate = false;
      if (rerun) {
        log('Pending re-evaluate found, scheduling');
        this.debouncedEvaluate();
      } else {
        this._grantPending = false;
      }
      document.dispatchEvent(new CustomEvent('bxgy:evaluate-done'));
      if (!err) this._injectFreeGiftCTAs(true);
      if (!rerun) this._flushIdleWaiters();
    }

    _processOffers(cart, index) {
      if (index >= this.offers.length) {
        log('All offers processed');
        return Promise.resolve();
      }

      var self = this;
      var offer = this.offers[index];
      log('Processing offer', index + 1, 'of', this.offers.length, '| id:', offer.id, '| title:', offer.title);

      return this._evaluateOffer(cart, offer).then(function (result) {
        var mutated = result === true || !!(result && result.mutated);
        var nextCart = result && result.cart ? result.cart : null;
        log('Offer', offer.id, 'evaluation result: mutated =', mutated);
        if (mutated && nextCart) {
          return self._processOffers(nextCart, index + 1);
        }
        if (mutated) {
          log('Cart was mutated, re-fetching cart before next offer');
          return self._fetchCart().then(function (updatedCart) {
            log('Cart re-fetched after mutation:', updatedCart.items.length, 'items');
            return self._processOffers(updatedCart, index + 1);
          });
        }
        return self._processOffers(cart, index + 1);
      });
    }

    _evaluateOffer(cart, offer) {
      if (!isWithinSchedule(offer, Date.now())) {
        log('Offer', offer.id, '| outside its schedule, skipping');
        return Promise.resolve(false);
      }

      var qualifyingCount = this.countQualifyingItems(cart, offer);
      var existingRewards = this.getExistingRewards(cart, offer);
      var existingCount = existingRewards.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      var targetQty = this._targetQuantity(offer, qualifyingCount);
      var mode = offer.rewardSelectionMode || 'all';

      log('Offer', offer.id, '| qualifyingCount:', qualifyingCount, '| existingRewards:', existingCount, '| targetQty:', targetQty, '| mode:', mode);

      if (this._rewardRemoved.has(String(offer.id))) {
        var removedData = this._rewardRemoved.get(String(offer.id));
        var removedHash = this._qualifyingHash(cart, offer);
        log('Offer', offer.id, '| reward was manually removed by user | variantId:', removedData.variantId, '| setting opt-out');
        this._rewardRemoved.delete(String(offer.id));
        this.optOuts.set(offer.id, removedHash);
        this._saveSessionOptOut(offer.id, removedData.variantId, removedHash);
        return Promise.resolve(false);
      }

      var optedOut = this.optOuts.get(offer.id);
      if (optedOut) {
        var currentQualHash = this._qualifyingHash(cart, offer);
        log('Offer', offer.id, '| opt-out detected | stored hash:', optedOut, '| current hash:', currentQualHash);
        if (optedOut !== currentQualHash) {
          log('Offer', offer.id, '| qualifying items changed, clearing opt-out');
          this.optOuts.delete(offer.id);
        } else {
          log('Offer', offer.id, '| still opted out, skipping');
          return Promise.resolve(false);
        }
      }

      var sessionOpt = this._sessionOptOuts[String(offer.id)];
      if (sessionOpt) {
        var sessionHash = this._qualifyingHash(cart, offer);
        if (sessionOpt.hash !== sessionHash) {
          log('Offer', offer.id, '| session opt-out cleared (qualifying items changed) | stored hash:', sessionOpt.hash, '| current:', sessionHash);
          this._removeSessionOptOut(offer.id);
        } else {
          log('Offer', offer.id, '| session opt-out active | variantId:', sessionOpt.variantId, '| skipping');
          return Promise.resolve(false);
        }
      }

      if (mode === 'customer_chooses') {
        if (targetQty > 0 && existingCount < targetQty) {
          var parentInfo = this._getParentLineKey(cart, offer);
          var remainingQty = targetQty - existingCount;
          var maxQty = offer.maxRewardSelections > 0 ? Math.min(offer.maxRewardSelections, remainingQty) : remainingQty;
          log('Offer', offer.id, '| showing reward picker (customer_chooses) | maxQty:', maxQty, '| remainingQty:', remainingQty);
          this.showRewardPicker(offer, maxQty, this._qualifyingHash(cart, offer), undefined, parentInfo.key, parentInfo.productId, parentInfo.handle);
          return Promise.resolve(false);
        }
        if (existingCount > targetQty) {
          log('Offer', offer.id, '| need to remove excess rewards:', existingCount - targetQty);
          return this.removeRewards(cart, offer, existingCount - targetQty);
        }
        log('Offer', offer.id, '| no action needed');
        return Promise.resolve(false);
      }

      return this._reconcileAllMode(cart, offer, existingRewards, targetQty);
    }

    _targetQuantity(offer, qualifyingCount) {
      var minQualifying = offer.minQualifyingQuantity || 1;
      if (qualifyingCount < minQualifying) return 0;
      var targetQty = qualifyingCount * (offer.rewardQuantity || 1);
      if (offer.maxUsesPerOrder && offer.maxUsesPerOrder > 0) {
        targetQty = Math.min(targetQty, offer.maxUsesPerOrder);
      }
      return targetQty;
    }

    _allModeTargets(offer, targetQty) {
      var targets = {};
      var vids = offer._rewardVariantIds;
      if (!vids.length || targetQty <= 0) return targets;
      var base = Math.floor(targetQty / vids.length);
      var remainder = targetQty % vids.length;
      vids.forEach(function (vid, index) {
        var qty = base + (index < remainder ? 1 : 0);
        if (qty > 0) targets[String(vid)] = qty;
      });
      return targets;
    }

    _rememberedFailure(cart, offer) {
      var failure = this._grantFailures.get(String(offer.id));
      if (!failure) return null;
      if (failure.hash !== this._qualifyingHash(cart, offer)) {
        log('Offer', offer.id, '| qualifying items changed since the last failed grant, retry allowed');
        this._grantFailures.delete(String(offer.id));
        return null;
      }
      return failure;
    }

    _forgetFailure(offerId) {
      this._grantFailures.delete(String(offerId));
      this._readRetried.delete(String(offerId));
    }

    _reconcileAllMode(cart, offer, existingRewards, targetQty) {
      var self = this;
      var targets = this._allModeTargets(offer, targetQty);
      var allowance = {};
      Object.keys(targets).forEach(function (vid) { allowance[vid] = targets[vid]; });

      var updates = {};
      existingRewards.forEach(function (line) {
        var vid = String(line.variant_id);
        var allowed = allowance[vid] || 0;
        var keep = Math.min(line.quantity, allowed);
        allowance[vid] = allowed - keep;
        if (keep !== line.quantity) {
          log('Offer', offer.id, '| reward line', line.key, 'variant', vid, 'qty', line.quantity, '-> ', keep);
          updates[line.key] = keep;
        }
      });

      var deficits = {};
      var failure = this._rememberedFailure(cart, offer);
      Object.keys(allowance).forEach(function (vid) {
        if (allowance[vid] <= 0) return;
        if (failure && failure.failedVids[vid]) {
          log('Offer', offer.id, '| variant', vid, 'failed earlier for this cart, not retrying until the cart changes');
          return;
        }
        deficits[vid] = allowance[vid];
      });

      var hasUpdates = Object.keys(updates).length > 0;
      var hasDeficits = Object.keys(deficits).length > 0;
      log('Offer', offer.id, '| targets:', targets, '| updates:', updates, '| deficits:', deficits);

      if (!hasUpdates && !hasDeficits) {
        log('Offer', offer.id, '| no action needed');
        return Promise.resolve(false);
      }

      var chain = hasUpdates ? this._updateLineQuantities(offer, updates, hasDeficits) : Promise.resolve(false);
      if (hasDeficits) {
        chain = chain.then(function (updated) {
          return self.addRewardsAll(offer, deficits, updated ? null : cart).then(function (outcome) {
            return { mutated: outcome.mutated || updated, cart: outcome.cart };
          });
        });
      }
      return chain;
    }

    /* ── Helpers ── */

    _cartFetch(path, opts) {
      opts = opts || {};
      opts.bxgySelf = true;
      opts.headers = assign({}, opts.headers || {}, { 'X-BXGY-Self': '1' });
      return fetch(cartUrl(path), opts);
    }

    _fetchCart() {
      return this._cartFetch('cart.js', { method: 'GET', headers: JSON_HEADERS })
        .then(function (res) {
          if (!res.ok) throw new Error('cart fetch failed with status ' + res.status);
          return res.json();
        })
        .catch(function (err) {
          var wrapped = err instanceof Error ? err : new Error(String(err));
          wrapped.bxgyCartRead = true;
          throw wrapped;
        });
    }

    _findLineByKey(cart, key) {
      if (!key) return null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) return cart.items[i];
      }
      return null;
    }

    _rewardQuantitiesByVariant(lines) {
      var quantities = {};
      lines.forEach(function (line) {
        var vid = String(line.variant_id);
        quantities[vid] = (quantities[vid] || 0) + line.quantity;
      });
      return quantities;
    }

    _qualifyingHash(cart, offer) {
      var ids = [];
      cart.items.forEach(function (item) {
        if (item.properties && item.properties._bxgy_reward === 'true') return;
        if (offer._qualifyingIds.indexOf(item.product_id) !== -1) {
          ids.push(item.product_id + ':' + item.quantity);
        }
      });
      return ids.sort().join(',');
    }

    countQualifyingItems(cart, offer) {
      var count = 0;
      cart.items.forEach(function (item) {
        if (item.properties && item.properties._bxgy_reward === 'true') {
          log('Offer', offer.id, '| skipping reward item variant:', item.variant_id, 'from qualifying count');
          return;
        }
        if (offer._qualifyingIds.indexOf(item.product_id) !== -1) {
          log('Offer', offer.id, '| qualifying item found: product', item.product_id, ', variant', item.variant_id, ', qty:', item.quantity);
          count += item.quantity;
        }
      });
      log('Offer', offer.id, '| total qualifying count:', count);
      return count;
    }

    _getParentLineKey(cart, offer) {
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.properties && item.properties._bxgy_reward === 'true') continue;
        if (offer._qualifyingIds.indexOf(item.product_id) !== -1) {
          log('Offer', offer.id, '| parent line key found:', item.key, 'for product', item.product_id, 'handle', item.handle);
          return { key: item.key, productId: item.product_id, handle: item.handle || null };
        }
      }
      log('Offer', offer.id, '| no parent line key found');
      return { key: null, productId: null, handle: null };
    }

    _isSameProduct(offer, vid, parentProductId, parentHandle) {
      var rewardProductId = offer._rewardVariantProductMap[vid];
      if (parentProductId && rewardProductId != null) {
        var match = Number(rewardProductId) === Number(parentProductId);
        log('Offer', offer.id, '| _isSameProduct via productId: vid', vid, '| rewardProductId:', rewardProductId, '| parentProductId:', parentProductId, '| match:', match);
        return match;
      }
      var rewardHandle = offer._rewardVariantHandleMap[vid];
      if (parentHandle && rewardHandle) {
        var handleMatch = rewardHandle === parentHandle;
        log('Offer', offer.id, '| _isSameProduct via handle: vid', vid, '| rewardHandle:', rewardHandle, '| parentHandle:', parentHandle, '| match:', handleMatch);
        return handleMatch;
      }
      log('Offer', offer.id, '| _isSameProduct: no data to compare for vid', vid);
      return false;
    }

    getExistingRewards(cart, offer) {
      var rewards = cart.items.filter(function (item) {
        return item.properties && item.properties._bxgy_offer_id === String(offer.id);
      });
      log('Offer', offer.id, '| existing reward items:', rewards.map(function (r) { return { variant_id: r.variant_id, qty: r.quantity, key: r.key }; }));
      return rewards;
    }

    _findOfferById(id) {
      for (var i = 0; i < this.offers.length; i++) {
        if (String(this.offers[i].id) === String(id)) return this.offers[i];
      }
      return null;
    }

    /* ── Parent line properties ── */

    _mergeOfferEntry(existing, offerId, value) {
      var parts = (existing || '')
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
      var entry = String(offerId) + ':' + String(value);
      if (parts.indexOf(entry) === -1) parts.push(entry);
      return parts.join(',');
    }

    _stripOfferEntries(existing, offerId) {
      var prefix = String(offerId) + ':';
      var parts = (existing || '')
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean)
        .filter(function (entry) { return entry.indexOf(prefix) !== 0; });
      return parts.join(',');
    }

    _writeLineProperties(line, updater) {
      var existingProps = line.properties || {};
      var newProps = {};
      Object.keys(existingProps).forEach(function (k) { newProps[k] = existingProps[k]; });
      newProps = updater(newProps) || newProps;
      log('_writeLineProperties: key', line.key, '| properties:', newProps);
      return this._cartFetch('cart/change.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ id: line.key, properties: newProps }),
      })
        .then(function (res) {
          if (!res.ok) {
            console.warn('[BXGY] _writeLineProperties: /cart/change.js failed | status:', res.status);
            return false;
          }
          return true;
        })
        .catch(function (err) {
          console.error('[BXGY] _writeLineProperties error', err);
          return false;
        });
    }

    _recordDeclinedSku(offerId, sku) {
      var self = this;
      if (!offerId || !sku) {
        log('_recordDeclinedSku: missing offerId or sku, skipping', { offerId: offerId, sku: sku });
        return Promise.resolve(false);
      }
      var offer = this._findOfferById(offerId);
      if (!offer) {
        log('_recordDeclinedSku: offer not found, skipping', offerId);
        return Promise.resolve(false);
      }
      log('_recordDeclinedSku: recording', sku, 'for offer', offerId);

      return this._fetchCart()
        .then(function (cart) {
          var parentLine = self._findLineByKey(cart, self._getParentLineKey(cart, offer).key);
          if (!parentLine) {
            log('_recordDeclinedSku: no parent X in cart, skipping');
            return false;
          }
          var existingDeclined = (parentLine.properties || {})._bxgy_declined_skus || '';
          var merged = self._mergeOfferEntry(existingDeclined, offerId, sku);
          if (merged === existingDeclined) {
            log('_recordDeclinedSku: SKU', sku, 'already recorded, skipping write');
            return false;
          }
          return self._writeLineProperties(parentLine, function (props) {
            props._bxgy_declined_skus = merged;
            return props;
          });
        })
        .catch(function (err) {
          console.error('[BXGY] _recordDeclinedSku: cart fetch failed', err);
          return false;
        });
    }

    _clearDeclinedSkusForOffer(offerId) {
      var self = this;
      if (!offerId) return Promise.resolve(false);
      var offer = this._findOfferById(offerId);
      if (!offer) return Promise.resolve(false);
      log('_clearDeclinedSkusForOffer: clearing entries for offer', offerId);

      return this._fetchCart()
        .then(function (cart) {
          var parentLine = self._findLineByKey(cart, self._getParentLineKey(cart, offer).key);
          if (!parentLine) return false;
          var existingDeclined = (parentLine.properties || {})._bxgy_declined_skus || '';
          if (!existingDeclined) return false;
          var stripped = self._stripOfferEntries(existingDeclined, offerId);
          if (stripped === existingDeclined) return false;
          return self._writeLineProperties(parentLine, function (props) {
            if (stripped) props._bxgy_declined_skus = stripped;
            else delete props._bxgy_declined_skus;
            return props;
          });
        })
        .catch(function (err) {
          console.error('[BXGY] _clearDeclinedSkusForOffer: cart fetch failed', err);
          return false;
        });
    }

    _clearGrantFailure(offer, cart) {
      var parentLine = this._findLineByKey(cart, this._getParentLineKey(cart, offer).key);
      if (!parentLine) return Promise.resolve(false);
      var existing = (parentLine.properties || {})[GRANT_FAILED_PROPERTY] || '';
      if (!existing) return Promise.resolve(false);
      var stripped = this._stripOfferEntries(existing, offer.id);
      if (stripped === existing) return Promise.resolve(false);
      if (this.getExistingRewards(cart, offer).length > 0) {
        log('Offer', offer.id, '| grant failure marker kept: reward lines already nested under parent');
        return Promise.resolve(false);
      }
      log('Offer', offer.id, '| clearing grant failure marker before re-adding');
      return this._writeLineProperties(parentLine, function (props) {
        if (stripped) props[GRANT_FAILED_PROPERTY] = stripped;
        else delete props[GRANT_FAILED_PROPERTY];
        return props;
      });
    }

    _recordGrantFailure(offer, cart, status) {
      var parentLine = this._findLineByKey(cart, this._getParentLineKey(cart, offer).key);
      if (!parentLine) return Promise.resolve(false);
      if (this.getExistingRewards(cart, offer).length > 0) {
        log('Offer', offer.id, '| grant failure marker skipped: reward lines already nested under parent');
        return Promise.resolve(false);
      }
      var existing = (parentLine.properties || {})[GRANT_FAILED_PROPERTY] || '';
      var merged = this._mergeOfferEntry(existing, offer.id, status);
      if (merged === existing) return Promise.resolve(false);
      log('Offer', offer.id, '| recording grant failure marker:', merged);
      return this._writeLineProperties(parentLine, function (props) {
        props[GRANT_FAILED_PROPERTY] = merged;
        return props;
      });
    }

    /* ── Error Notifications ── */

    showCartError(message) {
      log('showCartError:', message);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'bxgy',
          errors: message,
          message: message,
        });
      }

      document.dispatchEvent(new CustomEvent('cart:error', { detail: { message: message } }));

      try {
        var existing = document.getElementById('bxgy-error-notification');
        if (existing) existing.remove();

        var el = document.createElement('div');
        el.id = 'bxgy-error-notification';
        el.setAttribute('role', 'alert');
        el.setAttribute('aria-live', 'assertive');
        el.style.cssText =
          'position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:99999;' +
          'background:#fef2f2;color:#991b1b;border:1px solid #fca5a5;border-radius:8px;' +
          'padding:12px 20px;font-size:14px;max-width:90vw;box-shadow:0 4px 12px rgba(0,0,0,0.15);' +
          'display:flex;align-items:center;gap:8px;';
        var safeMessage = document.createElement('div');
        safeMessage.appendChild(document.createTextNode(message));

        el.innerHTML =
          '<span style="flex:1">' + safeMessage.innerHTML + '</span>' +
          '<button type="button" style="background:none;border:none;cursor:pointer;font-size:18px;color:#991b1b;padding:0 4px;" aria-label="Dismiss">&times;</button>';
        var dismiss = el.querySelector('button');
        if (dismiss) dismiss.addEventListener('click', function () { el.remove(); });

        document.body.appendChild(el);

        setTimeout(function () {
          if (el.parentNode) el.remove();
        }, 6000);
      } catch (e) {
        console.error('[BXGY] could not render error notification', e);
      }
    }

    /* ── Cart Mutations ── */

    _buildRewardItem(offer, vid, quantity, parentInfo) {
      var numVid = Number(vid);
      var item = {
        id: numVid,
        quantity: quantity,
        properties: {
          _bxgy_reward: 'true',
          _bxgy_offer_id: String(offer.id),
          _bxgy_selection_mode: offer.rewardSelectionMode || 'all',
          _bxgy_discount_message: this.discountMessages[offer.discountMessageHandle] || offer.discountMessage || this.t.default_message || 'Special Offer',
        },
      };
      if (offer.orderTag) {
        item.properties._bxgy_order_tag = offer.orderTag;
      }
      if (parentInfo.key && !this._isSameProduct(offer, numVid, parentInfo.productId, parentInfo.handle)) {
        item.parent_line_key = parentInfo.key;
      }
      return item;
    }

    addRewardsAll(offer, quantitiesByVid, cart) {
      var vids = offer._rewardVariantIds.slice();
      if (!vids.length) {
        log('Offer', offer.id, '| addRewardsAll: no variant IDs to add');
        return Promise.resolve({ mutated: false, cart: null });
      }
      var requested = [];
      vids.forEach(function (vid) {
        var qty = quantitiesByVid ? (quantitiesByVid[String(vid)] || 0) : 1;
        if (qty > 0) requested.push({ id: vid, quantity: qty });
      });
      if (!requested.length) {
        log('Offer', offer.id, '| addRewardsAll: nothing to add');
        return Promise.resolve({ mutated: false, cart: null });
      }
      log('Offer', offer.id, '| addRewardsAll: requesting', requested);
      return this._grantRewards(offer, requested, cart || null);
    }

    addRewardsFromSelection(offer, selections) {
      var requested = [];
      Object.keys(selections).forEach(function (vid) {
        if (selections[vid] > 0) requested.push({ id: Number(vid), quantity: selections[vid] });
      });
      log('Offer', offer.id, '| addRewardsFromSelection: selections:', selections, '| items to add:', requested.length);
      if (!requested.length) {
        log('Offer', offer.id, '| addRewardsFromSelection: nothing selected');
        return Promise.resolve({ mutated: false, cart: null });
      }
      this._forgetFailure(offer.id);
      return this._grantRewards(offer, requested, null);
    }

    _grantRewards(offer, requested, knownCart) {
      var self = this;
      var before = {};
      var preAddCart = null;
      var hadMarker = false;

      return Promise.resolve(knownCart || null)
        .then(function (cart) {
          return cart || self._fetchCart();
        })
        .then(function (cart) {
          return self._clearGrantFailure(offer, cart).then(function (cleared) {
            hadMarker = !!cleared;
            return cleared ? self._fetchCart() : cart;
          });
        })
        .then(function (cart) {
          preAddCart = cart;
          self._readRetried.delete(String(offer.id));
          var parentInfo = self._getParentLineKey(cart, offer);
          before = self._rewardQuantitiesByVariant(self.getExistingRewards(cart, offer));
          var items = requested.map(function (req) {
            return self._buildRewardItem(offer, req.id, req.quantity, parentInfo);
          });
          log('Offer', offer.id, '| adding', items.length, 'reward items | parent_line_key:', parentInfo.key);
          return self._postRewardItems(offer, items, before);
        })
        .then(function (outcome) {
          return self._verifyGrant(offer, outcome, before);
        })
        .then(function (outcome) {
          outcome.preAddCart = preAddCart;
          outcome.hadMarker = hadMarker;
          outcome.qualifyingHash = self._qualifyingHash(preAddCart, offer);
          return self._reportGrant(offer, outcome);
        })
        .catch(function (err) {
          var message = String((err && err.message) || err);
          if (err && err.bxgyCartRead) {
            console.warn('[BXGY] cart read failed during grant for offer', offer.id, '|', message);
            track(EVENT_GRANT_FAILED, self._eventBase(offer, {
              'Failure Type': 'cart_read',
              Failures: [{ status: 0, error: message }],
            }));
            if (!self._readRetried.has(String(offer.id))) {
              self._readRetried.set(String(offer.id), true);
              log('Offer', offer.id, '| scheduling one retry after the failed cart read');
              self.debouncedEvaluate();
            }
            return { mutated: false, cart: null };
          }
          console.error('[BXGY] grant error for offer', offer.id, err);
          track(EVENT_GRANT_FAILED, self._eventBase(offer, {
            'Failure Type': 'exception',
            Failures: [{ status: 0, error: message }],
          }));
          self.showCartError(self.t.error_generic || 'Something went wrong adding the reward item. Please try again.');
          return { mutated: false, cart: null };
        });
    }

    _postAdd(items) {
      return this._cartFetch('cart/add.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ items: items }),
      });
    }

    _readError(res) {
      return res
        .json()
        .catch(function () { return {}; })
        .then(function (body) {
          return (body && (body.description || body.message)) || '';
        });
    }

    _postRewardItems(offer, items, before) {
      var self = this;
      return this._postAdd(items).then(function (res) {
        if (res.ok) {
          log('Offer', offer.id, '| batch add succeeded for', items.length, 'items');
          return { granted: items.slice(), failed: [], mode: 'batch' };
        }
        return self._readError(res).then(function (batchError) {
          console.warn('[BXGY] batch add failed for offer', offer.id, '| status:', res.status, '|', batchError);
          return self._fetchCart().then(function (cart) {
            var after = self._rewardQuantitiesByVariant(self.getExistingRewards(cart, offer));
            var landed = [];
            var remaining = [];
            items.forEach(function (item) {
              var vid = String(item.id);
              var delta = (after[vid] || 0) - ((before && before[vid]) || 0);
              if (delta >= item.quantity) {
                landed.push(item);
              } else if (delta > 0) {
                landed.push(assign({}, item, { quantity: delta }));
                remaining.push(assign({}, item, { quantity: item.quantity - delta }));
              } else {
                remaining.push(item);
              }
            });
            if (landed.length) log('Offer', offer.id, '| rejected batch still added', landed.length, 'item(s)');
            if (!remaining.length) {
              return { granted: landed, failed: [], mode: 'batch-partial', batchStatus: res.status, batchError: batchError };
            }
            if (!landed.length && items.length === 1) {
              return { granted: [], failed: [{ item: items[0], status: res.status, error: batchError }], mode: 'batch' };
            }
            return self._postItemsIndividually(remaining).then(function (outcome) {
              outcome.granted = landed.concat(outcome.granted);
              outcome.mode = 'fallback';
              outcome.batchStatus = res.status;
              outcome.batchError = batchError;
              return outcome;
            });
          });
        });
      });
    }

    _postItemsIndividually(items) {
      var self = this;
      var outcome = { granted: [], failed: [] };
      return items
        .reduce(function (chain, item) {
          return chain.then(function () {
            return self
              ._postAdd([item])
              .then(function (res) {
                if (res.ok) {
                  outcome.granted.push(item);
                  return null;
                }
                return self._readError(res).then(function (msg) {
                  outcome.failed.push({ item: item, status: res.status, error: msg });
                });
              })
              .catch(function (err) {
                outcome.failed.push({ item: item, status: 0, error: String((err && err.message) || err) });
              });
          });
        }, Promise.resolve())
        .then(function () {
          return outcome;
        });
    }

    _verifyGrant(offer, outcome, before) {
      var self = this;
      if (!outcome.granted.length) return Promise.resolve(outcome);
      return this._fetchCart()
        .then(function (cart) {
          var after = self._rewardQuantitiesByVariant(self.getExistingRewards(cart, offer));
          var verified = [];
          outcome.granted.forEach(function (item) {
            var vid = String(item.id);
            var expected = (before[vid] || 0) + item.quantity;
            if ((after[vid] || 0) >= expected) {
              verified.push(item);
            } else {
              console.warn('[BXGY] reward variant', vid, 'missing from cart after add | expected', expected, 'found', after[vid] || 0);
              outcome.failed.push({ item: item, status: 'missing', error: 'reward not present in cart after add' });
            }
          });
          outcome.granted = verified;
          outcome.cart = cart;
          return outcome;
        })
        .catch(function (err) {
          log('verify grant: cart fetch failed', err);
          return outcome;
        });
    }

    _eventBase(offer, extra) {
      return assign(
        {
          'Offer ID': String(offer.id),
          'Offer Title': offer.title || '',
          'Selection Mode': offer.rewardSelectionMode || 'all',
          Market: this.currentMarket,
          'Routes Root': routesRoot(),
          Page: pageUrl(),
        },
        extra
      );
    }

    _reportGrant(offer, outcome) {
      var self = this;
      var granted = outcome.granted;
      var failed = outcome.failed;
      var grantedIds = granted.map(function (i) { return i.id; });
      var failedIds = failed.map(function (f) { return f.item ? f.item.id : null; });

      if (granted.length) {
        this._readRetried.delete(String(offer.id));
        track(EVENT_GRANTED, this._eventBase(offer, {
          'Reward Variant IDs': grantedIds,
          'Reward Quantities': granted.map(function (i) { return i.quantity; }),
          'Add Mode': outcome.mode,
        }));
      }

      if (failed.length) {
        var failedVids = {};
        failed.forEach(function (f) {
          if (f.item) failedVids[String(f.item.id)] = true;
        });
        this._grantFailures.set(String(offer.id), { hash: outcome.qualifyingHash || '', failedVids: failedVids });
        track(EVENT_GRANT_FAILED, this._eventBase(offer, {
          'Failure Type': failed.every(function (f) { return f.status === 'missing'; }) ? 'verify' : 'add',
          'Failed Variant IDs': failedIds,
          'Granted Variant IDs': grantedIds,
          'Add Mode': outcome.mode,
          'Batch Status': outcome.batchStatus || null,
          'Batch Error': outcome.batchError || null,
          Failures: failed.map(function (f) {
            return { variant_id: f.item ? f.item.id : null, status: f.status, error: f.error };
          }),
        }));
      } else {
        this._grantFailures.delete(String(offer.id));
      }

      if (failed.length && !granted.length) {
        var first = failed[0];
        var message = first.error || this.t.error_add || 'Could not add the reward item to your cart.';
        var cart = outcome.cart || outcome.preAddCart;
        var recorded = cart ? this._recordGrantFailure(offer, cart, first.status) : Promise.resolve(false);
        return recorded
          .catch(function () { return false; })
          .then(function (wrote) {
            if (outcome.hadMarker) {
              log('Offer', offer.id, '| grant failed again for a reward already marked as failed, not repeating the notice');
            } else {
              self.showCartError(message);
            }
            return { mutated: !!wrote || outcome.hadMarker, cart: null };
          });
      }

      if (failed.length) {
        this.showCartError(this.t.error_partial || 'Only some of the reward items could be added to your cart.');
      }

      log('Offer', offer.id, '| granted', granted.length, 'reward items | refreshing cart UI + opening drawer');
      this.refreshCartUI(true);
      return Promise.resolve({ mutated: true, cart: outcome.cart || null });
    }

    _updateLineQuantities(offer, updates, skipRefresh) {
      var self = this;
      log('Offer', offer.id, '| updating reward line quantities:', updates);
      return this._cartFetch('cart/update.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ updates: updates }),
      })
        .then(function (res) {
          if (!res.ok) {
            console.warn('[BXGY] /cart/update.js failed for offer', offer.id, '| status:', res.status);
            return false;
          }
          if (!skipRefresh) self.refreshCartUI();
          return true;
        })
        .catch(function (err) {
          console.error('[BXGY] Remove error', err);
          return false;
        });
    }

    removeRewards(cart, offer, excess) {
      var rewards = this.getExistingRewards(cart, offer);
      var updates = {};

      var remaining = excess;
      log('Offer', offer.id, '| removeRewards: removing', excess, 'units across', rewards.length, 'reward line items');
      for (var i = rewards.length - 1; i >= 0 && remaining > 0; i--) {
        var lineQty = rewards[i].quantity;
        if (remaining >= lineQty) {
          updates[rewards[i].key] = 0;
          remaining -= lineQty;
        } else {
          updates[rewards[i].key] = lineQty - remaining;
          remaining = 0;
        }
      }

      if (Object.keys(updates).length === 0) {
        log('Offer', offer.id, '| removeRewards: nothing to remove');
        return Promise.resolve(false);
      }

      return this._updateLineQuantities(offer, updates);
    }

    /* ── Change Selection (cart drawer button) ── */

    installChangeSelectionHandler() {
      var self = this;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('.bxgy-change-selection-btn');
        if (!btn) return;

        var offerId = btn.getAttribute('data-bxgy-offer-id');
        if (!offerId) return;

        log('Change selection button clicked for offer:', offerId);
        var offer = self._findOfferById(offerId);
        if (!offer || offer.rewardSelectionMode !== 'customer_chooses') {
          log('Change selection: offer not found or not customer_chooses mode');
          return;
        }

        e.preventDefault();
        log('Opening edit picker for offer', offerId);
        self.showRewardPickerForEdit(offer);
      });
    }

    /* ── Reward Picker (template-based) ── */

    showRewardPickerForEdit(offer) {
      var self = this;
      log('Offer', offer.id, '| showRewardPickerForEdit: fetching cart for current selections');
      this._fetchCart()
        .then(function (cart) {
          var existingRewards = self.getExistingRewards(cart, offer);
          var currentSelections = {};
          existingRewards.forEach(function (item) {
            var vid = item.variant_id;
            currentSelections[vid] = (currentSelections[vid] || 0) + item.quantity;
          });

          var targetQty = self._targetQuantity(offer, self.countQualifyingItems(cart, offer));
          var maxQty = offer.maxRewardSelections > 0 ? Math.min(offer.maxRewardSelections, targetQty) : targetQty;
          log('Offer', offer.id, '| showRewardPickerForEdit: maxQty:', maxQty, '| targetQty:', targetQty);

          var parentInfo = self._getParentLineKey(cart, offer);
          log('Offer', offer.id, '| showRewardPickerForEdit: current selections:', currentSelections, '| parentLineKey:', parentInfo.key);
          self.showRewardPicker(offer, maxQty, self._qualifyingHash(cart, offer), currentSelections, parentInfo.key, parentInfo.productId, parentInfo.handle);
        })
        .catch(function (err) {
          console.error('[BXGY] showRewardPickerForEdit failed', err);
        });
    }

    /* ── Variant Availability ── */

    _fetchVariantAvailability(products) {
      var self = this;
      var handleMap = {};
      products.forEach(function (p) {
        if (p.productHandle) {
          handleMap[p.productHandle] = true;
        }
      });
      var handles = Object.keys(handleMap);
      if (!handles.length) {
        log('No product handles found, skipping availability check');
        return Promise.resolve({});
      }

      log('Fetching availability for handles:', handles);
      var fetches = handles.map(function (handle) {
        return fetch(cartUrl('products/' + handle + '.js'))
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      });

      return Promise.all(fetches).then(function (results) {
        var availability = {};
        results.forEach(function (productData) {
          if (!productData) return;
          var rawTags = productData.tags || [];
          var tags = (Array.isArray(rawTags) ? rawTags : rawTags.split(',')).map(function (t) { return t.trim().toLowerCase(); });
          var variants = productData.variants || [];

          var gOpsAvailable = tags.indexOf('inventory-unavailable: g-ops') === -1;
          var gOpsEpiAvailable = tags.indexOf('inventory-unavailable: g-ops-epi') === -1;
          var mainFreightAvailable = tags.indexOf('inventory-unavailable: mainfreight') === -1;
          var hasGarageNashville = tags.indexOf('inventory-unavailable: nashville') === -1;
          var hasGarageLondon = tags.indexOf('inventory-unavailable: london') === -1;
          var hasGarageMiami = false;

          var market = self.currentMarket;

          variants.forEach(function (v) {
            var isSoldOut = !v.available;

            if (!isSoldOut) {
              if (market === 'us') {
                var usWarehouseAvailable = gOpsAvailable || gOpsEpiAvailable;
                var usGarageAvailable = hasGarageNashville || hasGarageMiami;
                if (!usWarehouseAvailable && !usGarageAvailable) {
                  isSoldOut = true;
                }
              } else if (market === 'europe' || market === 'united-kingdom') {
                var euWarehouseAvailable = mainFreightAvailable;
                var euGarageAvailable = hasGarageLondon;
                if (!euWarehouseAvailable && !euGarageAvailable) {
                  isSoldOut = true;
                }
              }
            }

            availability[v.id] = !isSoldOut;
          });
        });
        log('Variant availability map:', availability);
        return availability;
      });
    }

    showRewardPicker(offer, maxQty, qualifyingHash, existingSelections, parentLineKey, parentProductId, parentHandle) {
      if (document.querySelector('.bxgy-overlay')) {
        log('Offer', offer.id, '| showRewardPicker: popup already open, skipping');
        return;
      }

      var self = this;
      var products = offer.rewardProducts || [];
      if (!products.length) {
        log('Offer', offer.id, '| showRewardPicker: no reward products defined');
        return;
      }

      var isEdit = !!existingSelections;
      log('Offer', offer.id, '| showRewardPicker: mode:', isEdit ? 'edit' : 'new', '| maxQty:', maxQty, '| products:', products.length);

      products.forEach(function (p) {
        p._vid = extractNumericId(p.variantId) || p.numericVariantId;
      });

      this._fetchVariantAvailability(products).then(function (variantAvailability) {
        self._renderRewardPicker(offer, products, maxQty, qualifyingHash, existingSelections, parentLineKey, parentProductId, parentHandle, isEdit, variantAvailability);
      });
    }

    _renderRewardPicker(offer, products, maxQty, qualifyingHash, existingSelections, parentLineKey, parentProductId, parentHandle, isEdit, variantAvailability) {
      var self = this;
      var soldOutVids = {};

      products.forEach(function (p) {
        var vid = p._vid;
        if (Object.keys(variantAvailability).length > 0 && variantAvailability[vid] === false) {
          soldOutVids[vid] = true;
        }
      });
      log('Offer', offer.id, '| sold-out variants:', Object.keys(soldOutVids));

      var selections = {};
      products.forEach(function (p) {
        var vid = p._vid;
        if (soldOutVids[vid]) {
          selections[vid] = 0;
        } else {
          selections[vid] = (existingSelections && existingSelections[vid]) ? existingSelections[vid] : 0;
        }
      });

      function getTotal() {
        var t = 0;
        Object.keys(selections).forEach(function (k) { t += selections[k]; });
        return t;
      }

      var pickerTpl = document.querySelector(PICKER_TEMPLATE);
      if (!pickerTpl) {
        console.error('[BXGY] Picker template not found (' + PICKER_TEMPLATE + ')');
        return;
      }
      var fragment = pickerTpl.content.cloneNode(true);

      var overlay = fragment.querySelector('.bxgy-overlay');
      var heading = fragment.querySelector('[data-bxgy="heading"]');
      var closeBtn = fragment.querySelector('[data-bxgy="close"]');
      var grid = fragment.querySelector('[data-bxgy="grid"]');
      var counter = fragment.querySelector('[data-bxgy="counter"]');
      var submitBtn = fragment.querySelector('[data-bxgy="submit"]');

      var customHeading = self.pickerHeadings[offer.pickerHeadingHandle];
      if (customHeading) {
        heading.textContent = customHeading;
      } else {
        heading.textContent = isEdit ? (self.t.heading_edit || 'Change your reward items') : (self.t.heading_new || 'Choose your reward items');
      }
      submitBtn.textContent = isEdit ? (self.t.submit_update || 'Update Selection') : (self.t.submit_add || 'Add to Cart');

      var cardTpl = document.querySelector(CARD_TEMPLATE);
      var qtyInputs = {};
      var plusBtns = {};
      var minusBtns = {};

      products.forEach(function (product) {
        var cardFragment = cardTpl.content.cloneNode(true);
        var card = cardFragment.querySelector('.bxgy-product-card');
        var img = cardFragment.querySelector('[data-bxgy="card-img"]');
        var title = cardFragment.querySelector('[data-bxgy="card-title"]');
        var variant = cardFragment.querySelector('[data-bxgy="card-variant"]');
        var price = cardFragment.querySelector('[data-bxgy="card-price"]');
        var minusBtn = cardFragment.querySelector('[data-bxgy="card-minus"]');
        var qtyInput = cardFragment.querySelector('[data-bxgy="card-qty"]');
        var plusBtn = cardFragment.querySelector('[data-bxgy="card-plus"]');

        var vid = product._vid;
        var isSoldOut = !!soldOutVids[vid];

        if (isSoldOut) {
          card.classList.add('sold-out');
        }

        if (product.imageUrl) {
          img.src = product.imageUrl;
          img.alt = product.productTitle;
        } else {
          img.remove();
        }

        title.textContent = product.productTitle;

        if (product.variantTitle && product.variantTitle !== 'Default Title') {
          variant.textContent = product.variantTitle;
        } else {
          variant.remove();
        }

        var originalPrice = parseFloat(product.price) || 0;
        var discountedPrice = originalPrice;
        if (offer.discountType === 'fixed_amount' && offer.discountFixedAmount) {
          discountedPrice = Math.max(0, originalPrice - offer.discountFixedAmount);
        } else if (offer.discountPercentage) {
          discountedPrice = originalPrice * (1 - offer.discountPercentage / 100);
        }
        discountedPrice = Math.max(0, discountedPrice);

        var cs = self.currencySymbol;
        if (discountedPrice === 0) {
          price.textContent = self.t.free || 'FREE';
        } else if (discountedPrice < originalPrice) {
          price.innerHTML = '<s style="color:#6d7175">' + cs + originalPrice.toFixed(2) + '</s> ' + cs + discountedPrice.toFixed(2);
        } else {
          price.textContent = cs + originalPrice.toFixed(2);
        }

        if (isSoldOut) {
          var soldOutLabel = document.createElement('p');
          soldOutLabel.className = 'bxgy-sold-out-label';
          soldOutLabel.textContent = self.t.sold_out || 'Sold Out';
          card.querySelector('.bxgy-product-info').appendChild(soldOutLabel);
        }

        qtyInput.value = String(selections[vid]);
        qtyInput.setAttribute('aria-label', (self.t.quantity_label || 'Quantity for __TITLE__').replace('__TITLE__', product.productTitle));
        minusBtn.disabled = isSoldOut || selections[vid] <= 0;
        plusBtn.disabled = isSoldOut;

        qtyInputs[vid] = qtyInput;
        plusBtns[vid] = plusBtn;
        minusBtns[vid] = minusBtn;

        if (!isSoldOut) {
          plusBtn.addEventListener('click', function () {
            if (getTotal() >= maxQty) return;
            selections[vid]++;
            qtyInput.value = String(selections[vid]);
            log('Offer', offer.id, '| picker: + clicked for variant', vid, '| new qty:', selections[vid], '| total:', getTotal());
            updateUI();
          });

          minusBtn.addEventListener('click', function () {
            if (selections[vid] <= 0) return;
            selections[vid]--;
            qtyInput.value = String(selections[vid]);
            log('Offer', offer.id, '| picker: - clicked for variant', vid, '| new qty:', selections[vid], '| total:', getTotal());
            updateUI();
          });
        }

        grid.appendChild(cardFragment);
      });

      var counterTpl = self.t.counter || 'Selected: __COUNT__ of __MAX__';
      function counterText(n) {
        return counterTpl.replace('__COUNT__', n).replace('__MAX__', maxQty);
      }

      var initTotal = getTotal();
      counter.textContent = counterText(initTotal);
      submitBtn.disabled = initTotal < 1;

      document.body.appendChild(fragment);
      log('Offer', offer.id, '| picker: popup rendered');

      var liveOverlay = document.querySelector('.bxgy-overlay');

      function updateUI() {
        var total = getTotal();
        counter.textContent = counterText(total);
        submitBtn.disabled = total < 1;

        products.forEach(function (product) {
          var vid = product._vid;
          if (soldOutVids[vid]) return;
          minusBtns[vid].disabled = selections[vid] <= 0;
          plusBtns[vid].disabled = total >= maxQty;
        });
      }

      if (isEdit) updateUI();

      function closePopup() {
        log('Offer', offer.id, '| picker: popup closed');
        if (liveOverlay) liveOverlay.remove();
      }

      closeBtn.addEventListener('click', function () {
        if (!isEdit) {
          log('Offer', offer.id, '| picker: user dismissed without adding, setting opt-out');
          self.optOuts.set(offer.id, qualifyingHash);
          self._saveSessionOptOut(offer.id, null, qualifyingHash);
        }
        closePopup();
        log('Offer', offer.id, '| picker: dismissed, scheduling re-evaluate for remaining offers');
        self.debouncedEvaluate();
      });

      liveOverlay.addEventListener('click', function (e) {
        if (e.target === liveOverlay) {
          if (!isEdit) {
            log('Offer', offer.id, '| picker: overlay clicked (dismissed), setting opt-out');
            self.optOuts.set(offer.id, qualifyingHash);
            self._saveSessionOptOut(offer.id, null, qualifyingHash);
          }
          closePopup();
          log('Offer', offer.id, '| picker: dismissed via overlay, scheduling re-evaluate for remaining offers');
          self.debouncedEvaluate();
        }
      });

      submitBtn.addEventListener('click', function () {
        log('Offer', offer.id, '| picker: add/update button clicked | selections:', JSON.stringify(selections));
        submitBtn.disabled = true;
        submitBtn.textContent = isEdit ? (self.t.submit_updating || 'Updating...') : (self.t.submit_adding || 'Adding...');

        var finishAdd = function () {
          return self.addRewardsFromSelection(offer, selections).then(function () {
            self.optOuts.delete(offer.id);
            self._removeSessionOptOut(offer.id);
            closePopup();
            log('Offer', offer.id, '| picker: rewards added, scheduling re-evaluate for remaining offers');
            self.debouncedEvaluate();
          });
        };

        if (isEdit) {
          log('Offer', offer.id, '| picker: edit mode — removing existing rewards first');
          self._fetchCart()
            .then(function (cart) {
              var existingRewards = self.getExistingRewards(cart, offer);
              var totalRewardQty = existingRewards.reduce(function (sum, item) { return sum + item.quantity; }, 0);
              if (totalRewardQty > 0) {
                log('Offer', offer.id, '| picker: removing', totalRewardQty, 'existing reward units before re-adding');
                return self.removeRewards(cart, offer, totalRewardQty);
              }
              return true;
            })
            .then(function (removed) {
              if (removed === false) {
                log('Offer', offer.id, '| picker: remove failed, aborting update');
                submitBtn.disabled = false;
                submitBtn.textContent = self.t.submit_update || 'Update Selection';
                return null;
              }
              log('Offer', offer.id, '| picker: existing rewards removed, adding new selections');
              return finishAdd();
            })
            .catch(function (err) {
              console.error('[BXGY] picker edit failed', err);
              submitBtn.disabled = false;
              submitBtn.textContent = self.t.submit_update || 'Update Selection';
            });
        } else {
          finishAdd();
        }
      });
    }

    /* ── Free Gift CTA ── */

    _injectFreeGiftCTAs(forceClean) {
      if (this._injectingCTAs) return;
      this._injectingCTAs = true;
      var self = this;

      if (forceClean) {
        log('_injectFreeGiftCTAs: forceClean — removing all existing CTAs');
        var existing = document.querySelectorAll('.bxgy-free-gift-cta');
        for (var i = 0; i < existing.length; i++) {
          existing[i].remove();
        }
      }

      this._fetchCart()
        .then(function (cart) {
          for (var oi = 0; oi < self.offers.length; oi++) {
            var offer = self.offers[oi];
            var mode = offer.rewardSelectionMode || 'all';

            var memoryOpt = self.optOuts.get(offer.id);
            var sessionOpt = self._sessionOptOuts[String(offer.id)];
            if (!memoryOpt && !sessionOpt) continue;

            var qualCount = self.countQualifyingItems(cart, offer);
            if (qualCount < (offer.minQualifyingQuantity || 1)) continue;

            var existingRewards = self.getExistingRewards(cart, offer);
            if (mode === 'all') {
              var ctaTargets = self._allModeTargets(offer, self._targetQuantity(offer, qualCount));
              var present = self._rewardQuantitiesByVariant(existingRewards);
              var complete = true;
              Object.keys(ctaTargets).forEach(function (vid) {
                if ((present[vid] || 0) < ctaTargets[vid]) complete = false;
              });
              if (complete) continue;
            } else {
              if (existingRewards.length > 0) continue;
            }

            var cartIndex = -1;
            for (var ci = 0; ci < cart.items.length; ci++) {
              var item = cart.items[ci];
              if (item.properties && item.properties._bxgy_reward === 'true') continue;
              if (offer._qualifyingIds.indexOf(item.product_id) !== -1) {
                cartIndex = ci + 1;
                break;
              }
            }
            if (cartIndex === -1) continue;

            var row = document.getElementById('CartDrawer-Item-' + cartIndex);
            if (!row) {
              log('_injectFreeGiftCTAs: #CartDrawer-Item-' + cartIndex + ' not found');
              continue;
            }

            if (row.querySelector('.bxgy-free-gift-cta')) continue;

            var detailsTd = row.querySelector('td .cart-drawer__quantity');
            if (!detailsTd) {
              log('_injectFreeGiftCTAs: .cart-drawer__quantity not found in row', cartIndex);
              continue;
            }

            var ctaDiv = document.createElement('div');
            ctaDiv.className = 'bxgy-free-gift-cta';
            var ctaBtn = document.createElement('button');
            ctaBtn.type = 'button';
            ctaBtn.className = 'bxgy-free-gift-cta__link';
            ctaBtn.textContent = self.t.free_gift_cta || 'Eligible for a special offer';
            ctaBtn.setAttribute('data-bxgy-offer-id', offer.id);
            ctaDiv.appendChild(ctaBtn);

            detailsTd.parentNode.insertBefore(ctaDiv, detailsTd.nextSibling);
            log('_injectFreeGiftCTAs: injected CTA for offer', offer.id, 'at CartDrawer-Item-' + cartIndex);

            (function (boundOffer) {
              ctaBtn.addEventListener('click', function () {
                var clickMode = boundOffer.rewardSelectionMode || 'all';
                log('CTA clicked for offer', boundOffer.id, '| mode:', clickMode, '| clearing opt-out and declined SKUs');
                self.optOuts.delete(boundOffer.id);
                self._removeSessionOptOut(boundOffer.id);
                self._rewardRemoved.delete(String(boundOffer.id));
                self._forgetFailure(boundOffer.id);

                var allCtas = document.querySelectorAll('.bxgy-free-gift-cta');
                for (var r = 0; r < allCtas.length; r++) {
                  allCtas[r].remove();
                }

                var cleared = self._clearDeclinedSkusForOffer(boundOffer.id);

                if (clickMode === 'all') {
                  cleared.then(
                    function () { self.evaluate(); },
                    function () { self.evaluate(); }
                  );
                  return;
                }

                self._fetchCart()
                  .then(function (freshCart) {
                    var targetQty = self._targetQuantity(boundOffer, self.countQualifyingItems(freshCart, boundOffer));
                    var maxQty = boundOffer.maxRewardSelections > 0 ? Math.min(boundOffer.maxRewardSelections, targetQty) : targetQty;
                    var parentInfo = self._getParentLineKey(freshCart, boundOffer);
                    self.showRewardPicker(boundOffer, maxQty, self._qualifyingHash(freshCart, boundOffer), undefined, parentInfo.key, parentInfo.productId, parentInfo.handle);
                  })
                  .catch(function (err) {
                    log('CTA click: failed to open picker', err);
                    self.debouncedEvaluate();
                  });
              });
            })(offer);
          }

          self._injectingCTAs = false;
        })
        .catch(function (err) {
          log('_injectFreeGiftCTAs error:', err);
          self._injectingCTAs = false;
        });
    }

    /* ── Cart UI Refresh ── */

    refreshCartUI(openDrawer) {
      var self = this;
      var drawerEl = document.getElementById('CartDrawer');
      var drawerSectionId = (drawerEl && drawerEl.getAttribute && drawerEl.getAttribute('data-id')) || 'cart-drawer';
      var bubbleSectionId = 'cart-icon-bubble';
      var seq = ++this._refreshSeq;
      this._pendingOpen = !!this._pendingOpen || !!openDrawer;
      log('refreshCartUI: fetching sections', drawerSectionId + ',' + bubbleSectionId, '| openDrawer:', !!openDrawer);

      fetch(cartUrl('?sections=' + drawerSectionId + ',' + bubbleSectionId))
        .then(function (res) {
          if (!res.ok) throw new Error('sections fetch failed with status ' + res.status);
          return res.json();
        })
        .then(function (sections) {
          if (seq !== self._refreshSeq) {
            log('refreshCartUI: a newer refresh is in flight, ignoring this response');
            return;
          }
          var shouldOpen = !!self._pendingOpen;
          self._pendingOpen = false;
          var drawerHTML = sections[drawerSectionId];
          var bubbleHTML = sections[bubbleSectionId];

          if (drawerHTML) {
            if (drawerEl) {
              var temp = document.createElement('div');
              temp.innerHTML = drawerHTML;
              var newDrawer = temp.querySelector('#CartDrawer');
              if (newDrawer) {
                drawerEl.innerHTML = newDrawer.innerHTML;
                log('refreshCartUI: cart drawer updated');
              } else {
                log('refreshCartUI: #CartDrawer not found in fetched HTML');
              }
            } else {
              log('refreshCartUI: #CartDrawer element not in DOM');
            }
          } else {
            log('refreshCartUI: no drawer section in response');
          }

          if (bubbleHTML) {
            var bubbleEl = document.getElementById(bubbleSectionId);
            if (bubbleEl) {
              bubbleEl.innerHTML = bubbleHTML;
              log('refreshCartUI: cart icon bubble updated');
            } else {
              log('refreshCartUI: #cart-icon-bubble element not in DOM');
            }
          } else {
            log('refreshCartUI: no cart-icon-bubble section in response');
          }

          log('refreshCartUI: dispatching cart:refresh event');
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          if (shouldOpen) {
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              log('refreshCartUI: opening cart drawer');
              cartDrawer.open();
            } else {
              log('refreshCartUI: cart-drawer element not found or no open() method');
            }
          }
        })
        .catch(function (err) {
          console.error('[BXGY] UI refresh error', err);
        });
    }
  }

  if (document.readyState === 'loading') {
    log('DOM not ready, waiting for DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', function () {
      log('DOMContentLoaded fired');
      new BxgyManager();
    });
  } else {
    log('DOM already ready, initializing immediately');
    new BxgyManager();
  }
})();
